const sign = () => (Math.random() > 0.5 ? 1 : -1);

const range = (min, max) => min + Math.random() * (max - min);

const rangeInt = (min, max) => Math.floor(min + Math.random() * (max - min));

const item = (array) => array[Math.floor(Math.random() * array.length)];

function items(arr, n)
{
	var result = new Array(n),
		len = arr.length,
		taken = new Array(len);
	if (n > len)
		throw new RangeError("getRandom: more elements taken than available");
	while (n--)
	{
		var x = Math.floor(Math.random() * len);
		result[n] = arr[x in taken ? taken[x] : x];
		taken[x] = --len in taken ? taken[len] : len;
	}
	return result;
}


export default {
	sign,
	range,
	rangeInt,
	item,
	items
}